import { configureStore } from '@reduxjs/toolkit';
import {useDispatch as useAppDispatch,useSelector as useAppSelector,TypedUseSelectorHook} from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { rootPersistConfig,rootReducer} from './rootReducer';
import { stellarApi } from '../api/stellar';
import { ebioroApi } from '../api/ebioro/ebioro';
import {recoveryServerApi} from '../api/recovery-servers/recovery.servers';
import {depositWithdrawApi} from '../api/deposit-withdraw/deposit-withdraw';
import { coinGeckoApi } from '../api/coin-gecko/coingecko';
import { moonPayClientApi } from '../api/moonpay/moonpay';

// ----------------------------------------------------------------------

const store = configureStore({
  reducer: persistReducer(rootPersistConfig , rootReducer),
  
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat([stellarApi.middleware,ebioroApi.middleware,depositWithdrawApi.middleware,coinGeckoApi.middleware,recoveryServerApi.middleware,moonPayClientApi.middleware]),
});

const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

const useDispatch = () => useAppDispatch<AppDispatch>();

const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { store, persistor, dispatch, useSelector, useDispatch };
